import React from 'react';
import { Title, Body } from "@vds/typography";
import styled from 'styled-components';


const PaddingStyle = styled.div`
padding-top:48px;
padding-bottom:24px;
`
const StyledPaddingDiv1 = styled.div`
padding-top:24px;


`
const StyledPaddingDiv0 = styled.div`
padding-top:16px;


`
const StyledPaddingDiv3 = styled.div`
padding-bottom:16px;


`

//PlanInfo 

const PlanInfo = ({ planInfo }) => {

    let planInfoContent = planInfo?.categoryContent[0]?.content;

    return (
        <React.Fragment>
            <>
                {planInfoContent && planInfoContent.map((item, index) => (
                    <React.Fragment>

                        <PaddingStyle> <Title size="small">
                            {item &&
                                <span dangerouslySetInnerHTML={{ __html: item.header }} />}
                        </Title></PaddingStyle>

                        {item && item.shortdesc &&
                            <StyledPaddingDiv3 >
                                <Body size="medium">
                                    <span style={{ fontFamily: "Verizon-NHG-eDS,Helvetica,Arial,sans-serif" }} dangerouslySetInnerHTML={{ __html: item.shortdesc }} />
                                </Body>
                            </StyledPaddingDiv3>

                        }

                        {item && item.SubHeader &&
                            <>
                                <Body size="medium"><span dangerouslySetInnerHTML={{ __html: item.SubHeader }} /></Body>
                                <StyledPaddingDiv0></StyledPaddingDiv0></>
                        }


                        {item && item.istravelpass === "true" ?
                            <>
                                {item && item.value && item.value.map((ele, index) => (
                                    <>
                                        {index > 0 && <StyledPaddingDiv1></StyledPaddingDiv1>}
                                        <Body size="medium">
                                            {ele &&
                                                <span dangerouslySetInnerHTML={{ __html: ele.subHeader }} />}
                                        </Body>

                                        {ele && ele.subHeaderValue && ele.subHeaderValue.map((subHeaderEle, index) => (
                                            <ul
                                                size="bodyLarge"
                                                viewport="desktop"
                                                surface="light"
                                            >
                                                <li><Body size="medium"><span dangerouslySetInnerHTML={{ __html: subHeaderEle.key }} /></Body></li>


                                                {subHeaderEle && subHeaderEle.sub && subHeaderEle.sub.map((subHeaderEleSub, index) => (

                                                    <ul>
                                                        <li><Body size="medium"><span dangerouslySetInnerHTML={{ __html: subHeaderEleSub.key }} /></Body></li>
                                                    </ul>))}


                                            </ul>
                                        ))}
                                    </>
                                ))}


                            </>
                            :
                            <>
                                {item && item.value && item.value.map((elem, index) => (
                                    <ul
                                        size="bodyLarge"
                                        viewport="desktop"
                                        surface="light"
                                    >
                                        <Body size="medium">
                                            <li><span dangerouslySetInnerHTML={{ __html: elem.key }} /></li>
                                        </Body>

                                        {elem && elem.sub && elem.sub.map((subelem, index) => (
                                            <ul>
                                                <li><Body size="medium"><span dangerouslySetInnerHTML={{ __html: subelem.key }} /></Body></li></ul>))}


                                    </ul>
                                ))}
                            </>}

                        {item && item.note &&
                            <StyledPaddingDiv1>
                                <Body>
                                    <span dangerouslySetInnerHTML={{ __html: item.note }} />
                                </Body>
                            </StyledPaddingDiv1>

                        }

                        {item && item.smartphonetitle &&
                            <div style={{ paddingTop: "10px" }}>
                                <StyledPaddingDiv1 style={{
                                    backgroundColor: "black",
                                    margin: "10px", textAlign: "center", color: "white", width: "45%", padding: "10px 15px 24px ", borderRadius: "10px", minheight: "15vh"
                                }}>
                                    <Body>
                                        <Title ><p style={{ color: "white", fontSize: "20px", paddingBottom: "6px" }} dangerouslySetInnerHTML={{ __html: item.planidheader }} /></Title>
                                        <div style={{ display: "flex", marginLeft: "10px", color: "white" }}>
                                            <p dangerouslySetInnerHTML={{ __html: item.smartphonetitle }} />
                                            <p style={{ marginLeft: "25%" }} dangerouslySetInnerHTML={{ __html: item.basicphonetitle }} />
                                        </div>
                                        <div style={{ display: "flex", marginLeft: "10px", color: "white" }}>
                                            <p dangerouslySetInnerHTML={{ __html: item.smartphoneid }} />
                                            <p style={{ marginLeft: "44%" }} dangerouslySetInnerHTML={{ __html: item.basicphoneid }} />
                                        </div>

                                    </Body>


                                </StyledPaddingDiv1>
                            </div>}

                    </React.Fragment>))}
            </>
        </React.Fragment>)

}


export default PlanInfo 
